import React from 'react';
import { Box, Typography } from '@mui/material';
import { Check } from '@procore/core-icons';
import { useStyles } from './ClaimedBadge.styles';

const ClaimOutline = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.06094 0C4.70825 0 4.38164 0.185792 4.20139 0.48895L0.303847 7.04436C0.116581 7.35932 0.116582 7.75149 0.303847 8.06646L4.20139 14.6219C4.38164 14.925 4.70825 15.1108 5.06094 15.1108H12.9095C13.2611 15.1108 13.5868 14.9262 13.7674 14.6245L17.6924 8.06911C17.8818 7.75282 17.8818 7.35799 17.6924 7.04171L13.7674 0.486299C13.5868 0.184642 13.2611 0 12.9095 0H5.06094Z"
        fill="#FF5200"
      />
    </svg>
  );
};

interface Props {
  text: string;
  claimedContainerStyle?: string;
}

const ClaimedBadge = ({ text, claimedContainerStyle }: Props) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      alignItems="flex-start"
      className={claimedContainerStyle}
    >
      <Box className={classes.outline}>
        <ClaimOutline />
        <Check size="sm" className={classes.check} />
      </Box>
      <Typography className={classes.text}>{text}</Typography>
    </Box>
  );
};

export default ClaimedBadge;
